module.exports = __webpack_public_path__ + "static/media/reflow-sticky5.300f68d1.png";